import type { DiskussionPost } from '../../types';

const QUOTE_MAX_LENGTH = 400;

function bodyToPlainText(body: string): string {
  if (!body) return '';
  if (typeof document === 'undefined') {
    return body.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const el = document.createElement('div');
  el.innerHTML = body;
  return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
}

function truncateText(text: string, maxLen: number): string {
  if (text.length <= maxLen) return text;
  return `${text.slice(0, maxLen).trimEnd()}…`;
}

function formatAuthorName(post: DiskussionPost): string {
  if (post.autor) {
    return `${post.autor.vorname} ${post.autor.nachname}`.trim();
  }
  return 'Unbekannt';
}

function formatTimestamp(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('de-DE');
}

/** Erzeugt HTML fuer ein statisches Zitat eines Beitrags (Antwort-Editor). */
export function buildQuoteHtml(post: DiskussionPost): string {
  const author = formatAuthorName(post);
  const ts = formatTimestamp(post.erstellt_am);
  const excerpt = truncateText(bodyToPlainText(post.body), QUOTE_MAX_LENGTH);
  const safeExcerpt = excerpt
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return (
    `<blockquote>` +
    `<p><strong>${author}</strong> · ${ts} · ` +
    `<a href="#post-${post.id}">Beitrag #${post.id}</a></p>` +
    `<p>${safeExcerpt}</p>` +
    `</blockquote><p></p>`
  );
}
